import * as React from "react"
import { GetQueryString } from "../../utils/utils"
import config from "../../utils/config"
import request from "../../utils/request"

interface IProps {
  className?: string
  phone: any
}

export default class TakePhone extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props)
  }

  public render() {
    // return this.props.phone ? (
    //   <a
    //     href="#"
    //     onClick={() => this.takePhone()}
    //     className={`take-phone ${this.props.className || ""}`}
    //   >
    //     <img src={require("../../assets/images/take-phone.png")} />
    //   </a>
    // ) : null
    return (
      <a
        href="#"
        onClick={() => this.takePhone()}
        className={`take-phone ${this.props.className || ""}`}
      >
        <img src={require("../../assets/images/take-phone.png")} />
      </a>
    )
  }
  private async takePhone() {
    window.location.href = "tel:" + (this.props.phone || "15907538884")
    return
    const gid =
      window.location.pathname.indexOf("/offer/") > -1
        ? GetQueryString("id")
        : ""
    const r = request({
      data: {
        shopDomain: (window as any).shopId,
        gid,
      },
      method: "post",
      url: config.PHPAPI + "api/wshop/default/bind",
    })

    r.then((res) => {
      if (res.error_code === 0) {
        window.location.href = "tel:" + res.data.tel
      } else {
        ;(window as any).alert(res.msg)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/shop/take-phone.tsx